import { render, staticRenderFns } from "./AutocompleteLabel.vue?vue&type=template&id=6aced1f8"
import script from "./AutocompleteLabel.vue?vue&type=script&lang=js"
export * from "./AutocompleteLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports